module.exports = __webpack_public_path__ + "static/media/YB5F04_0.d7765978.jpg";